"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tacAuthorizationStatusRetrieve = exports.mfaSendOtp = exports.accesHardWareSubmit = exports.accessElevationValidate = exports.accessElevationRequest = void 0;
const requestUtil_1 = require("../requestUtil");
const configurations_1 = require("../configurations");
const accessElevationRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.SOFT_TOKEN_REQUEST;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.accessElevationRequest = accessElevationRequest;
const accessElevationValidate = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.ACCESS_ELEVATION_VALIDATE;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.accessElevationValidate = accessElevationValidate;
const accesHardWareSubmit = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_SECURITY + configurations_1.PATH.HARD_TOKEN_VALIDATE;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.accesHardWareSubmit = accesHardWareSubmit;
const mfaSendOtp = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.MFA_SEND_OTP;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.mfaSendOtp = mfaSendOtp;
const tacAuthorizationStatusRetrieve = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.TAC_TOKEN_RETRIEVE;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.tacAuthorizationStatusRetrieve = tacAuthorizationStatusRetrieve;
